gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate, ...args) {
  let timeout;
  return function () {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

$(document).ready(() => {
  let wWidth = $(window).width();
  const $header = $('.page-header');
  let isObserver = true;
  let isDeliveryOpened = false;
  let isNavOpened = false;
  let observer;

  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('isIntersecting' in window.IntersectionObserverEntry.prototype)
  ) {
    isObserver = false;
    $('html').removeClass('is-observer');
  }

  if (isObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {rootMargin: '0px 0px -15% 0px'}
    );
  }

  function disableScrolling() {
    const docHeight = document.body.clientHeight;
    const windowHeight = window.innerHeight;

    if (docHeight > windowHeight) {
      const html = document.documentElement;
      const {scrollTop} = html;
      html.classList.add('disable-scrolling');
      html.style.top = `${-scrollTop}px`;
    }
  }

  function enableScrolling() {
    const {top} = getComputedStyle(document.documentElement);
    const scrollTop = parseInt(top, 10);
    const html = document.documentElement;
    html.classList.remove('disable-scrolling');
    html.scrollTop = -scrollTop;
  }

  function bindEvents() {
    const $hamburger = $header.find('.page-header__open');
    const $menuClose = $header.find('.page-header__close');
    const $delivery = $header.find('.delivery');
    const $deliveryClose = $delivery.find('.delivery__close');

    const $bookingPopup = $header.find('.booking-popup');
    const $bookingPopupInner = $bookingPopup.find('.booking-popup__inner');
    const $bookingClose = $bookingPopup.find('.booking-popup__close');

    $hamburger.on('click', () => {
      $header.addClass('is-opened');
      disableScrolling();
      isNavOpened = true;
    });

    $menuClose.on('click', () => {
      if (isDeliveryOpened) {
        $header.removeClass('is-delivery-popup');
        isDeliveryOpened = false;
        if (!isNavOpened) {
          enableScrolling();
        }
      } else {
        $header.removeClass('is-opened');
        isNavOpened = false;
        enableScrolling();
      }
    });

    if ($(".hero--pub").length > 0) {
      if ($(".visit-us").length > 0) {
        $(".visit-us .story-card__content .story-card__cta").clone().appendTo(".hero--pub .hero-visit-us");
      }
    }

      if ($(".subnav").length > 0) {
        // Automatically trigger the first subnav link
        $(".subnav a").eq(0).trigger("click");

        setTimeout(function () {
          if (!window.location.hash) {
            $(".subnav a").eq(0).addClass("active");
          }
        }, 200);

        // Handle hash on page load
        updateContent(window.location.hash.replace("#", ""));
      }

      if ($(".subnav").length > 0) {
        console.log("is subnav");
        // The Crown (Booking Hotel Widget)
        if (window.location.href.includes("the-crown")) {
          const iframe = `<iframe src="https://app.thebookingbutton.com/properties/TheCrownRoomsDirect/booking_widget" width="230" height="230" frameborder="0" scrolling="no"></iframe>`;
          $(".story-card.book .story-card__copy").append(iframe);
        }

        // The Ship (Booking Hotel Widget)
        if (window.location.href.includes("the-ship")) {
          console.log("is the ship");
          const iframe = `<iframe src="https://app.thebookingbutton.com/properties/TheShipDirect/booking_widget" width="230" height="230" frameborder="0" scrolling="no"></iframe>`;
          $(".story-card.book .story-card__copy").append(iframe);
        }
      }

      // Event Listener for Navigation Clicks
      $(".subnav a").on("click", function (e) {
        e.preventDefault();
        const target = $(this).data("target");

        // Update URL hash
        window.location.hash = target;

        // Update UI based on the new hash
        updateContent(target);
      });

      // Function to handle content visibility based on hash
      function updateContent(target) {
        $(".is-events, .matchpint, .story-card, .banner, .intro-copy, .grid, .copy-block, .booking-info, .drinks, .food").hide();

        // Find the correct section to show
        if (!target || target === "intro") {
          $(".intro-copy.intro, .grid").show();
        } else if (target === "whats-on") {
          $(".is-events, .matchpint, .intro-copy.whats-on").show();
        } else if (target === "food") {
          $(".food").show();
        } else if (target === "drinks") {
          $(".drinks").show();
        } else if (target === "visit-us") {
          $(".story-card.visit-us").show();
        } else if (target === "book") {
          $(".booking-info").show();
          $(".story-card.book").show();
        } else {
          // Generic case for dynamically targeting elements
          $("." + target).show();
        }

        // Update Active Class in Navigation
        $(".subnav a").removeClass("active");
        $(".subnav a[data-target='" + target + "']").addClass("active");
      }


    $('a').on('click', (e) => {
      const {hash} = e.currentTarget;

      if (hash === '#delivery') {
        e.preventDefault();
        e.stopPropagation();

        $header.addClass('is-delivery-popup');
        isDeliveryOpened = true;

        if (!isNavOpened) {
          disableScrolling();
        }
      }

      if (hash === '#book-a-table') {
        e.preventDefault();
        $header.addClass('is-booking-popup');

        if (!isNavOpened) {
          disableScrolling();
        }
      }
    });

    $("#bookingSelect").on('change', function() {
      let selectedOption = $(this).find(':selected');
      let selectedBooking = selectedOption.data('booking');

      if (selectedBooking === 'zonal') {
        $('.booking-zonal').trigger('click');
      }

      if (selectedBooking === 'design-my-night' || selectedBooking === 'dojo') {
        let url = selectedOption[0].getAttribute('data-url');

        if (url) {
          window.location.href = url;
        } else {
          console.error("URL is undefined for the selected option.");
        }
      }
    });


    $deliveryClose.on('click', () => {
      $header.removeClass('is-delivery-popup');
      isDeliveryOpened = false;

      if (!isNavOpened) {
        enableScrolling();
      }
    });

    $delivery.on('click', (e) => {
      e.stopPropagation();
    });

    $bookingClose.on('click', () => {
      $header.removeClass('is-booking-popup');

      if (!isNavOpened) {
        enableScrolling();
      }
    });

    $bookingPopupInner.on('click', (e) => {
      e.stopPropagation();
    });

    $bookingPopup.on('click', () => {
      $header.removeClass('is-booking-popup');
      enableScrolling();
    });

    $(window).on('click', () => {
      if (isDeliveryOpened) {
        $header.removeClass('is-delivery-popup');
        isDeliveryOpened = false;

        if (!isNavOpened) {
          enableScrolling();
        }
      }
    });

    // FOCUS STYLING
    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('is-tab');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.body.classList.add('is-tab');
      }
    });
  }

  function initSlider() {
    const $blocks = $('.slider');
    $blocks.each((i, el) => {
      const $block = $(el);
      const $swiperEl = $block.find('.slider__swiper');
      const $prev = $block.find('.swiper-controls__prev');
      const $next = $block.find('.swiper-controls__next');

      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper($swiperEl[0], {
        // loop: true,
        slidesPerView: 'auto',
        speed: 1000,

        navigation: {
          nextEl: $next[0],
          prevEl: $prev[0],
        },
      });
    });
  }

  function initGridSlider() {
    const $blocks = $('.grid');
    $blocks.each((i, el) => {
      const $block = $(el);
      const $swiperEl = $block.find('.grid__swiper');
      const $prev = $block.find('.swiper-controls__prev');
      const $next = $block.find('.swiper-controls__next');

      if ($swiperEl.data('swiper')) {
        $swiperEl.data('swiper').destroy(true, true);
      }

      if ($(window).width() < 767) {
        const swiper = new Swiper($swiperEl[0], {
          slidesPerView: 'auto',
          speed: 1000,
          navigation: {
            nextEl: $next[0],
            prevEl: $prev[0],
          },
        });

        $swiperEl.data('swiper', swiper);
      }
    });
  }

  // Debounced resize event
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initGridSlider();
    }, 300); // Adjust debounce time as needed
  });

  const updateHeader = () => {
    const st = $(window).scrollTop();

    if (st > 100) {
      $header.addClass('is-scrolling');
    } else if ((!isDeliveryOpened && wWidth >= 768) || wWidth < 768) {
      $header.removeClass('is-scrolling');
    }
  };

  const handleResize = () => {
    const width = $(window).width();

    if (width !== wWidth) {
      wWidth = width;
    }
  };

  /* FUNCTION CALLS */
  /* ============= */
  bindEvents();
  initSlider();
  initGridSlider();

  if (isObserver) {
    $('.js-visibility').each((i, el) => {
      observer.observe(el);
    });
  }

  $(window).on('scroll', updateHeader);
  $(window).on('resize', handleResize);
});

class Map {
  constructor(el) {
    this.$container = $(el);
    this.$inner = this.$container.find('.map__inner');
    this.$pubs = this.$inner.find('.map__pubs');
    this.$swiper = this.$pubs.children('.map__slider');
    this.$swiperWrapper = this.$swiper.children('.swiper-wrapper');
    this.$nextBtn = this.$swiper.find('.swiper-button-next');
    this.$prevBtn = this.$swiper.find('.swiper-button-prev');
    this.$mapWrap = this.$container.find('.map__map');
    this.$mapEl = this.$mapWrap.children('#map');
    this.$controls = this.$mapWrap.children('.map__controls');
    this.$scaleUpEl = this.$controls.children('.map__btn--plus');
    this.$scaleDownEl = this.$controls.children('.map__btn--minus');
    this.$pubs = this.$container.find('.js-pub');
    this.$pubBtns = this.$pubs.find('.cta');
    this.iconMarker = `${theme.url}/img/map-pin.svg`;

    this.styles = [
        {
          "featureType": "all",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.province",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            },
            {
              "weight": "0.47"
            },
            {
              "saturation": "-60"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#F4F1E9"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape.natural.landcover",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#F4F1E9"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#F4F1E9"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#F4F1E9"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "color": "#FFFFFF"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#CFD1D1"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#CEEAF8"
            }
          ]
        }
      ]


    this.mapOptions = {
      center: new google.maps.LatLng(51.520016, -0.114339),
      zoom: 11,
      disableDefaultUI: true,
      styles: this.styles,
    };
    this.markers = [];
    this.infoWindows = [];

    this.initMap();
  }

  initMap() {
    // init map
    this.map = new google.maps.Map(this.$mapEl[0], this.mapOptions);

    // calculate scroll sizes
    this.calculateSizes();
    $(window).on('resize', debounce(this.calculateSizes, 500));

    // resize for swiper
    this.breakpoint = window.matchMedia('(min-width:768px)');
    this.breakpoint.addEventListener('change', () => {
      this.breakpointChecker();
    });
    this.breakpointChecker();

    this.addMarkers();
    this.initControls();
    this.initScrollHandle();

    // handle scrollbar clicks
    this.$pubBtns.on('click', (e) => {
      if (this.breakpoint.matches === true) {
        e.preventDefault();
        const $cur = $(e.currentTarget).parent('.js-pub');
        this.selectPub($cur);
      }
    });
  }

  breakpointChecker() {
    if (this.breakpoint.matches === true) {
      if (this.swiper !== undefined) this.swiper.destroy(true, true);
      this.$inner.css('max-height', `${this.swiperWrapperHeight}px`);
    } else if (this.breakpoint.matches === false) {
      this.initSwiper();
      this.$inner.css('max-height', 'auto');
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.$swiper[0], {
      loop: true,
      speed: 500,
      navigation: {
        nextEl: this.$nextBtn[0],
        prevEl: this.$prevBtn[0],
      },
    });

    this.swiper.on('slideChange', (swiper) => {
      const pubIndex = swiper.realIndex;
      const $currentPub = this.$pubs.eq(pubIndex);
      this.selectPub($currentPub);
    });
  }

  addMarkers() {
    this.$pubs.each((i, el) => {
      const $pub = $(el);
      const lat = $pub.data('lat');
      const lng = $pub.data('lng');
      const permalink = $pub.data('permalink');
      const title = $pub.data('title');
      const logo = $pub.data('logo');

      this.markers[i] = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: this.map,
        icon: this.iconMarker,
      });

      const contentString = `
        <div class="info">
          ${logo ? `<img src="${logo}" alt="${title}" />` : ``}
          <a href="${permalink}" class="cta cta--white">See more</a>
        </div>`;

      this.infoWindows[i] = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 190,
      });

      this.markers[i].addListener('click', () => {
        this.selectPub(this.$pubs.eq(i));
      });
    });

    // select first pub
    this.selectPub(this.$pubs.eq(0));
  }

  openInfoWindow(i) {
    // close all info windows
    for (let index = 0; index < this.infoWindows.length; index += 1) {
      if (index !== i) {
        this.infoWindows[index].close();
      }
    }

    this.infoWindows[i].open({
      anchor: this.markers[i],
      map: this.map,
      shouldFocus: false,
    });
  }

  initControls() {
    this.$scaleUpEl.on('click', () => {
      this.map.setZoom(this.map.getZoom() + 1);
    });

    this.$scaleDownEl.on('click', () => {
      this.map.setZoom(this.map.getZoom() - 1);
    });
  }

  selectPub($pub) {
    this.map.panTo(new google.maps.LatLng($pub.data('lat'), $pub.data('lng')));

    if (this.breakpoint.matches === true) {
      // open info window
      const index = $pub.index();
      this.openInfoWindow(index);
    }
  }



  calculateSizes() {
    this.innerHeight = this.$inner.height();
    this.swiperWrapperHeight = this.$swiperWrapper.height();
    this.maxScrollHeight =
      this.$swiperWrapper[0].scrollHeight - this.$swiperWrapper[0].clientHeight;
  }

  initScrollHandle() {
    ScrollTrigger.matchMedia({
      '(min-width: 768px)': () => {
        if (
          this.swiperWrapperHeight + this.maxScrollHeight >
          this.innerHeight
        ) {
          ScrollTrigger.create({
            trigger: this.$container[0],
            start: 'top top+=92px',
            pin: true,
            end: '+=200%',
            ease: 'power1.inOut',
            onUpdate: (self) => {
              gsap.set(this.$swiperWrapper[0], {
                scrollTo: Math.round(
                  this.maxScrollHeight * self.progress.toFixed(3)
                ),
              });
            },
          });
        }
      },
    });
  }
}

window.initMap = () => {
  const $map = $('.map');
  if ($map.length) {
    // eslint-disable-next-line no-new
    new Map($('.map'));
  }
};
